package gr.tech.GRAttestation.styles

import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.TextTransform
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.functions.min
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.attrsModifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.focus
import gr.tech.GRAttestation.styles.grstyles.Theme
import org.jetbrains.compose.web.css.*

val AuthLogoStyle = CssStyle {
    base {
        Modifier
            .maxWidth(200.px)
            .margin(bottom = 14.px)
    }
}

val AuthTitleStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .margin(0.px)
            .fontSize(17.px)
            .fontWeight(700)
            .color(Theme.DarkGreen.rgb)
            .textAlign(TextAlign.Center)
    }
}

val AuthSubtitleStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .margin(top = 4.px, bottom = 0.px)
            .fontSize(12.px)
            .color(rgb(74, 112, 112))
            .textAlign(TextAlign.Center)
    }
}

val AuthErrorStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .textAlign(TextAlign.Center)
            .color(Colors.Red)
            .fontSize(1.cssRem)
            .margin(top = (-10).px, bottom = 10.px)
            .fontWeight(500)
    }
}

val AuthBoxStyle = CssStyle {
    base {
        Modifier
            .fillMaxSize()
            .background(Theme.GreenTint.rgb)
    }
}

val AuthCardStyle = CssStyle {
    base {
        Modifier
            .maxWidth(440.px)
            .width(min(440.px, 100.percent - 40.px))
            .background(Colors.White)
            .borderRadius(14.px)
            .boxShadow(
                offsetX = 0.px,
                offsetY = 1.px,
                blurRadius = 3.px,
                color = rgba(0, 0, 0, 0.06)
            )
            .border(1.px, LineStyle.Solid, rgb(208, 224, 218))
            .margin(topBottom = 1.cssRem)
    }
}

val AuthCardHeaderStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .padding(18.px, 26.px)
            .background(rgb(238, 246, 242))
            .borderBottom(1.px, LineStyle.Solid, rgb(208, 224, 218))
    }
}

val AuthLabelStyle = CssStyle {
    base {
        Modifier
            .display(DisplayStyle.Block)
            .fontSize(11.px)
            .fontWeight(600)
            .color(rgb(74, 112, 112))
            .margin(bottom = 5.px)
            .textTransform(TextTransform.Uppercase)
            .letterSpacing(0.08.em)
    }
}

val AuthInputStyle = CssStyle {
    base {
        Modifier
            .width(100.percent)
            .padding(9.px, 13.px)
            .border(1.5.px, LineStyle.Solid, rgb(184, 208, 198))
            .borderRadius(8.px)
            .fontSize(14.px)
            .background(rgb(252, 254, 252))
            .transition(Transition.all(250.ms))
            .attrsModifier {
                style {
                    property("outline", "none")
                    property("box-sizing", "border-box")
                }
            }
    }

    focus {
        Modifier
            .border(1.5.px, LineStyle.Solid, Theme.MediumGreen.rgb)
            .outline(1.5.px, LineStyle.Solid, Theme.MediumGreen.rgb)
    }
}

val AuthButtonStyle = CssStyle {
    base {
        Modifier
            .background(Theme.DarkGreen.rgb)
            .color(Colors.White)
            .borderRadius(10.px)
            .fontSize(14.px)
            .fontWeight(600)
            .boxShadow(
                offsetX = 0.px,
                offsetY = 2.px,
                blurRadius = 8.px,
                color = rgba(27, 94, 94, 0.3)
            )
            .attrsModifier {
                style {
                    property("border", "none")
                    property("cursor", "pointer")
                    property("transition", "transform 0.2s ease, box-shadow 0.2s ease")
                }
            }
    }

    cssRule(":hover:not(:disabled)") {
        Modifier
            .boxShadow(
                offsetX = 0.px,
                offsetY = 4.px,
                blurRadius = 12.px,
                color = rgba(27, 94, 94, 0.4)
            )
            .attrsModifier {
                style {
                    property("transform", "translateY(-1px)")
                }
            }
    }

    cssRule(":active:not(:disabled)") {
        Modifier
            .attrsModifier {
                style {
                    property("transform", "translateY(0px)")
                }
            }
    }

    cssRule(":disabled") {
        Modifier
            .opacity(0.6)
            .attrsModifier {
                style {
                    property("cursor", "not-allowed")
                }
            }
    }
}